<div *ngIf="tableData" class="table-responsive position-relative">
    <app-loading-spinner></app-loading-spinner>
    <span [appDisableTableOnRefresh]></span>
    <table [className]="'table info-table ' + tableData?.tableClasses">
        <thead [ngClass]="{ 'last-child-left': !!tableData.lastColumnLeft }">
            <tr>
                <th
                    scope="col"
                    *ngFor="
                        let header of tableData.headers
                            | keyvalue: originalOrder
                    "
                >
                    {{ header.value }}
                </th>
            </tr>
        </thead>
        <tbody *ngIf="tableData.data?.length > 0">
            <ng-container *ngFor="let row of data ; index as i">
                <tr
                    class="master"
                    (click)="tableData.rowClickCallback ? onRowClick(i) : null"
                    [ngClass]="{
                        'row-selected': row.rowSelected === 'true',
                        'row-not-selected': row.rowSelected === 'false',
                        disabled: row.rowDisabled,
                        odd: i % 2 === 0
                    }"
                >
                    <ng-container
                        *ngFor="
                            let item of row | keyvalue: originalOrder;
                            index as j
                        "
                    >
                        <td
                            *ngIf="
                                masterTableCell(item.key) &&
                                row[item.key].type !== 'NOT_SHOWN'
                            "
                            [ngClass]="{
                                'text-center': row[item.key].type === 'VALIDITY'
                            }"
                        >
                            <span [ngSwitch]="row[item.key].type">
                                <ng-container *ngSwitchCase="'VALIDITY'">
                                    <img
                                        *ngIf="
                                            row[item.key].value !== 'notChecked'
                                        "
                                        [src]="
                                            row[item.key].value === 'false'
                                                ? 'assets/images/warning_grey.png'
                                                : 'assets/images/success-status-icon-check.png'
                                        "
                                        class="icon-width"
                                    />
                                    <span
                                        *ngIf="
                                            row[item.key].value === 'notChecked'
                                        "
                                        >-</span
                                    >
                                </ng-container>

                                <ng-container *ngSwitchCase="'ACTION'">
                                    <div
                                        class="
                                            d-flex
                                            flex-column
                                            justify-content-center
                                            align-items-center
                                        "
                                    >
                                        <div
                                            *ngFor="
                                                let buttonConfig of row[
                                                    item.key
                                                ].value
                                            "
                                            class="app-button-wrapper"
                                        >
                                            <app-button
                                                *ngIf="
                                                    buttonConfig.label !== '-';
                                                    else toggle
                                                "
                                                [label]="buttonConfig.label"
                                                [hint]="buttonConfig.hint"
                                                [actionCallback]="
                                                    buttonConfig.actionCallback
                                                "
                                                [classes]="buttonConfig.classes"
                                                [disabled]="
                                                    row.rowDisabled ||
                                                    buttonConfig.disabled
                                                "
                                                [otherProperties]="
                                                    buttonConfig.otherProperties
                                                "
                                                [tip]="buttonConfig.tip"
                                            ></app-button>
                                            <ng-template #toggle>
                                                <app-toggle
                                                    [documentId]="
                                                        buttonConfig
                                                            .otherProperties
                                                            .documentId
                                                    "
                                                    [documentType]="
                                                        buttonConfig
                                                            .otherProperties
                                                            .documentType
                                                    "
                                                    [value]="
                                                        buttonConfig
                                                            .otherProperties
                                                            .documentState !==
                                                        'NOT_NEEDED'
                                                    "
                                                    (toggleChange)="
                                                        onToggleChange($event)
                                                    "
                                                ></app-toggle>
                                            </ng-template>
                                        </div>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'CHECKBOX'">
                                    <div class="custom-control custom-checkbox pl-5" [ngClass]="{'cursor-not-allowed': row[item.key].checkboxDisabled}">
                                        <input
                                            type="checkbox"
                                            class="custom-control-input"
                                            [id]="'customCheck' + i"
                                            [checked]="row[item.key].value"
                                            (change)="
                                                onCheckboxValueChanged(
                                                    tableData.data[i]
                                                )
                                            "
                                        />
                                        <label
                                            class="custom-control-label"
                                            [for]="'customCheck' + i"
                                            [ngClass]="{'pointer-events-none': row[item.key].checkboxDisabled}"
                                        ></label>
                                    </div>
                                </ng-container>

                                <ng-container *ngSwitchCase="'REFRESH'">
                                    <button
                                        *ngIf="row[item.key].value"
                                        else
                                        refreshDisabled
                                        [id]="i"
                                        [appRotateRefreshOnHttp]
                                        class="refresh-btn"
                                        (click)="
                                            onRefresh(tableData.data[i], i)
                                        "
                                    >
                                        <img
                                            class="refresh-icon-width"
                                            src="assets/images/refresh.png"
                                        />
                                    </button>

                                    <span #refreshDisabled></span>
                                </ng-container>

                                <ng-container *ngSwitchCase="'WARNING'">
                                    <span
                                        *ngIf="row[item.key].value"
                                        else
                                        noWarning
                                    >
                                        <img
                                            src="assets/images/icon-locker.png"
                                            class="mr-4 warning-icon"
                                        />
                                    </span>

                                    <span #noWarning></span>
                                </ng-container>

                                <ng-container *ngSwitchCase="'PLAIN_TEXT'">
                                    <!-- <span>{{ row[item.key].value }}</span> -->
                                        <span
                                        [innerHTML]="row[item.key].value"
                                    ></span>
                                    <span
                                    *ngIf="row[item.key]?.revertLink"
                                    style="text-decoration: underline; color: #003476; cursor: pointer;"
                                    (click)="onRevertLink(tableData.data[i], i)">
                                        <br><br>{{row[item.key]?.revertLink}}
                                    </span>
                                </ng-container>

                                <p *ngSwitchDefault>
                                    <span>{{ row[item.key].value }}</span>
                                </p>
                            </span>
                        </td>
                    </ng-container>
                </tr>
                <tr
                    *ngIf="row.rowDetails"
                    class="detail"
                    [ngClass]="{
                        'row-selected': row.rowSelected === 'true',
                        'row-not-selected': row.rowSelected === 'false',
                        disabled: row.rowDisabled,
                        odd: i % 2 === 0,
                        'pointer-events-none': row.rowDetails.documentApproved
                    }"
                >
                    <td [colSpan]="objectkeys(tableData.headers).length">
                        <div
                            [ngClass]="{
                                'row-selected': row.rowSelected === 'true',
                                'row-not-selected': row.rowSelected === 'false',
                                disabled: row.rowDisabled,
                                odd: i % 2 === 0
                            }"
                            style="
                                position: relative;
                                top: -38px;
                                left: -30px;
                                width: calc(100% + 30px);
                                height: 22px;
                                box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
                                clip-path: inset(0px -15px 3px -15px);
                            "
                        ></div>
                        <div class="container-fluid">
                            <ng-container
                                [ngTemplateOutlet]="
                                    detailRows._results[
                                        row.rowDetails.templateNumber
                                    ]
                                "
                                [ngTemplateOutletContext]="{
                                    $implicit: row.rowDetails,
                                    index: i,
                                    form: parentForm,
                                    docId: row.documentId
                                }"
                            ></ng-container>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
<div class="row" *ngIf="pagination">
  <div class="col-12">
    <ngb-pagination class="pull-right"
    [boundaryLinks]="true"
    [collectionSize]="tableData.data.length" [pageSize]="pageSize" [(page)]="page"></ngb-pagination>
  </div>
</div>
